export default {
  header: {
    notes: 'Header in set utilization target dialog',
    message: 'Set utilization targets',
  },
  help: {
    notes: 'Help in set utilization target dialog',
    message: 'Target/limit setting will be effective from this point onward',
  },
  loadedTarget: {
    notes: 'Loaded target header in set utilization target dialog',
    message: 'Loaded target',
  },
  idleLimitHours: {
    notes: 'Idle limit hours header in set utilization target dialog',
    message: 'Idle limit hours',
  },
  runtime: {
    notes: 'Runtime header in set utilization target dialog',
    message: 'Runtime',
  },
  idleLimitRelativeRuntime: {
    notes: 'Idle limit % of runtime in set utilization target dialog',
    message: 'Idle limit % of runtime',
  },
};
